import {
    GET_AI_NOTIFICATIONS_BEGINS,
    GET_AI_NOTIFICATIONS_SUCCESS,
    GET_AI_NOTIFICATIONS_FAILURE,
    CREATE_AI_NOTIFICATION_BEGINS,
    CREATE_AI_NOTIFICATION_SUCCESS,
    CREATE_AI_NOTIFICATION_FAILURE,
    UPDATE_AI_NOTIFICATION_BEGINS,
    UPDATE_AI_NOTIFICATION_SUCCESS,
    UPDATE_AI_NOTIFICATION_FAILURE,
} from '../constants';

const INITIAL_STATE = {
    isLoading: false,
    isSubmitting: false,
    aiNotifications: [],
    total: 0,
};

const aiNotificationsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_AI_NOTIFICATIONS_BEGINS:
            return { ...state, isLoading: true };
        case GET_AI_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                aiNotifications: action.data?.data || [],
                total: action.data?.total || 0,
            };
        case GET_AI_NOTIFICATIONS_FAILURE:
            return { ...state, isLoading: false };

        case CREATE_AI_NOTIFICATION_BEGINS:
        case UPDATE_AI_NOTIFICATION_BEGINS:
            return { ...state, isSubmitting: true };
        case CREATE_AI_NOTIFICATION_SUCCESS:
        case CREATE_AI_NOTIFICATION_FAILURE:
        case UPDATE_AI_NOTIFICATION_SUCCESS:
        case UPDATE_AI_NOTIFICATION_FAILURE:
            return { ...state, isSubmitting: false };

        default:
            return state;
    }
};

export default aiNotificationsReducer;